import {User} from '../interface/user.interface';
import {ThemeMode} from '../common/theme/theme';

export const SET_USER = 'COMMON/SET_USER';
export const SET_URL_PATH = 'COMMON/SET_URL_PATH';
export const SET_THEME_MODE = 'COMMON/SET_THEME_MODE';

const THEME_MODE_STORAGE_KEY = 'scc.themeMode';

const readInitialThemeMode = (): ThemeMode => {
    try {
        const stored = window.localStorage.getItem(THEME_MODE_STORAGE_KEY);
        if (stored === 'light' || stored === 'dark') return stored;
    } catch {
        /* localStorage unavailable (e.g. SSR or sandboxed iframe) */
    }
    return 'light';
};

const persistThemeMode = (mode: ThemeMode) => {
    try {
        window.localStorage.setItem(THEME_MODE_STORAGE_KEY, mode);
    } catch {
        /* ignore quota / unavailable */
    }
};

export const commonReducer = {
    setUser: (user: User) => ({type: SET_USER, user}),
    setUrlPath: (value: string) => ({type: SET_URL_PATH, value}),
    setThemeMode: (mode: ThemeMode) => {
        persistThemeMode(mode);
        return {type: SET_THEME_MODE, mode};
    },
};


interface State {
    user: User,
    urlPath: '',
    themeMode: ThemeMode,
}

const initialState: State = {
    user: {departmentName: '', id: '', admin: false, departmentCode: '', name: '', _id: ''},
    urlPath: '',
    themeMode: readInitialThemeMode(),
};

const commonData = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                user: {
                    ...initialState.user,
                    ...action.user
                },
            };
        case SET_URL_PATH:
            return {
                ...state,
                urlPath: action.value,
            };
        case SET_THEME_MODE:
            return {
                ...state,
                themeMode: action.mode,
            };
        default:
            return state;
    }
};

export default commonData;
